<template>
	<main class="main-container">
		<div class="cand-header d-flex mb-2 w-100" @click="goToPanelDashboard()">
			<!-- @click="$bvModal.show('candidateDetailsModal')" -->
			<img
				class="mr-3 pointer"
				src="../../assets/img/homepage/back-arrow-blue.svg"
				alt=""
			/>Your Interviews
		</div>

		<div class="my-2 int-body-main position-relative">
			<section class="int-control-tabs">
				<b-tabs content-class="mt-1 position-relative p-3" v-model="tabIndex">
					<section v-for="(interviews, index) in panelInterviews"
						:key="index"
						>
					<b-tab
						v-if="showTab(index)"
						:title="getLevelName(index)"
					>
						<div class="int-main-table">
							<div class="int-table-head">
								<div class="width-10 text-left pl-4">
									Interview ID
									<template v-if="interviews.length != 0">
										<template v-if="sortBy == 'interviewRequestID'">
											<img
												@click="sortData('interviewRequestID', -1)"
												v-if="sortOrder === 1"
												class="sort-img"
												src="@/assets/paneldashboard/up_sort.svg"
												alt=""
											/>
											<img
												v-else
												@click="sortData('interviewRequestID', 1)"
												class="sort-img"
												src="@/assets/paneldashboard/down_sort.svg"
												alt=""
											/>
										</template>
										<img
											v-else
											@click="sortData('interviewRequestID', 1)"
											class="sort-img"
											src="@/assets/paneldashboard/no_sort.svg"
											alt=""
										/>
									</template>
								</div>
								<div class="width-10 text-left">
									Candidate Name
									<template v-if="interviews.length != 0">
										<template v-if="sortBy == 'name'">
											<img
												@click="sortData('name', -1)"
												v-if="sortOrder === 1"
												class="sort-img"
												src="@/assets/paneldashboard/up_sort.svg"
												alt=""
											/>
											<img
												v-else
												@click="sortData('name', 1)"
												class="sort-img"
												src="@/assets/paneldashboard/down_sort.svg"
												alt=""
											/>
										</template>
										<img
											v-else
											@click="sortData('name', 1)"
											class="sort-img"
											src="@/assets/paneldashboard/no_sort.svg"
											alt=""
										/>
									</template>
								</div>
								<div class="w-15 text-left">
									Job Name
									<template v-if="interviews.length != 0">
										<template v-if="sortBy == 'jobName'">
											<img
												@click="sortData('jobName', -1)"
												v-if="sortOrder === 1"
												class="sort-img"
												src="@/assets/paneldashboard/up_sort.svg"
												alt=""
											/>
											<img
												v-else
												@click="sortData('jobName', 1)"
												class="sort-img"
												src="@/assets/paneldashboard/down_sort.svg"
												alt=""
											/>
										</template>
										<img
											v-else
											@click="sortData('jobName', 1)"
											class="sort-img"
											src="@/assets/paneldashboard/no_sort.svg"
											alt=""
										/>
									</template>
								</div>
								<div class="width-10 text-left">
									Role
									<template v-if="interviews.length != 0">
										<template v-if="sortBy == 'role'">
											<img
												@click="sortData('role', -1)"
												v-if="sortOrder === 1"
												class="sort-img"
												src="@/assets/paneldashboard/up_sort.svg"
												alt=""
											/>
											<img
												v-else
												@click="sortData('role', 1)"
												class="sort-img"
												src="@/assets/paneldashboard/down_sort.svg"
												alt=""
											/>
										</template>
										<img
											v-else
											@click="sortData('role', 1)"
											class="sort-img"
											src="@/assets/paneldashboard/no_sort.svg"
											alt=""
										/>
									</template>
								</div>

								<div class="w-15 text-left">Skills</div>
								<div class="w17 text-left">Time</div>
								<div class="width-8 text-left">Amount</div>
								<div class="w-15 text-center">Action</div>
							</div>
							<div class="int-table-body">
								<div v-if="showLoader[index]">
									<div class="int-table-row" v-for="n in 7" :key="n">
										<div class="width-10 text-left pl-4">
											<b-skeleton class="w-80"></b-skeleton>
										</div>

										<div class="width-10 text-left">
											<b-skeleton class="w-80"></b-skeleton>
										</div>
										<div class="w-15 text-left">
											<b-skeleton class="w-80"></b-skeleton>
										</div>

										<div class="width-10 text-left">
											<b-skeleton class="w-80"></b-skeleton>
										</div>

										<div class="w-15 text-left">
											<b-skeleton class="w-50"></b-skeleton>
										</div>

										<div class="w17 text-left">
											<b-skeleton class="w-80"></b-skeleton>
										</div>
										<div class="width-8 text-left">
											<b-skeleton class="w-50"></b-skeleton>
										</div>
										<div class="w-15 text-center">
											<b-skeleton class="w-90"></b-skeleton>
										</div>
									</div>
								</div>
								<section
									class="h-100 d-flex align-items-center justify-content-center flex-column"
									v-else-if="
										!showLoader[index] &&
										interviews.length == 0 &&
										searchQuery !== ''
									"
								>
									<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
									<div
										class="fs-14 fam-mont fw-LM color-344054 display-text-break"
									>
										No matching results for
										<strong> "{{ searchQuery }}" </strong>
									</div>
								</section>
								<template v-else-if="interviews.length == 0">
									<section
										class="h-100 d-flex align-items-center justify-content-center flex-column"
									>
										<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
										<div class="fs-14 fam-mont fw-LM color-344054">
											{{ getNoDataText(index) }}
										</div>
									</section>
								</template>
								<template v-else>
									<div
										class="int-table-row"
										v-for="interview in interviews"
										:key="interview.interviewRequestID"
									>
									    <div class="position-absolute d-flex tag-outer">
									    <div
											class="greenCard label-card"
											v-if="
											    showRescheduled(interview) &&
											    index != 2 && 
												getTime(interview.interviewRequestID) &&
												getTime(interview.interviewRequestID) != 'ongoing' &&
												interview.panelMeetingStatus != 0
											"
										>
											{{ getTime(interview.interviewRequestID) }}
										</div>
									    <div
											v-if="currentLevel == 1 && showRescheduleText(interview)"
											class="resched-card label-card"
										>
											Reschedule Requested
										</div>
										<div
											v-else-if="currentLevel == 1 && showRescheduled(interview)"
											class="rescheduled-card label-card"
										>
											Rescheduled
										</div>
										<div
											class="greenCard label-card"
											v-else-if="
											    !showRescheduled(interview) &&
											    index != 2 && 
												getTime(interview.interviewRequestID) &&
												getTime(interview.interviewRequestID) != 'ongoing' &&
												interview.panelMeetingStatus != 0
											"
										>
											{{ getTime(interview.interviewRequestID) }}
										</div>

										<div
											v-else-if="interview.panelMeetingStatus == 0"
											class="redCard label-card"
										>
											Cancelled
										</div>
									
										<div
											v-else-if="interview.outOfPrefenence"
											class="orangeCard label-card"
										>
											Out of Preferences
										</div>
										</div>
										<div class="blue-line"></div>
										<div class="width-10 text-left pl-4">
											<div class="text-truncate truncate-section" v-b-tooltip.hover="interview.interviewRequestID">{{
												interview.interviewRequestID
											}}</div>
										</div>
										<div class="width-10 text-left">
											<div class="text-truncate truncate-section" v-b-tooltip.hover="formattedData(interview.name)">{{
												formattedData(interview.name)
											}}</div>
										</div>
										<div class="w-15 text-left">
											<div class="text-truncate truncate-section"
												v-b-tooltip.hover="formattedData(interview.jobName)"
												>{{ formattedData(interview.jobName) }}</div
											>
										</div>
										<div class="width-10 text-left">
											<div class="text-truncate truncate-section" v-b-tooltip.hover="formattedData(interview.role)">{{
												formattedData(interview.role)
											}}</div>
										</div>

										<div class="w-15 text-left">
											<div class="text-truncate truncate-section"
												v-b-tooltip.hover="
													formattedArray(interview.skills).join(', ')
												"
											>
												{{ formattedArray(interview.skills).join(", ") }}</div
											>
										</div>

										<div class="w17 text-left">
											<div class="text-truncate truncate-section" v-b-tooltip.hover="getFormattedTime(interview)">
												{{ getFormattedTime(interview) }}</div
											>
										</div>
										<div class="width-8 text-left text-truncate">
											<article
												v-if="index == 2"
												v-b-tooltip.hover.bottom="
													getAmountToolTip(interview.paymentStatus)
												"
												class="rupee-tag d-flex align-items-center gap-2 fam-mont fw-M color-3a3c40"
											>
												<img
													:src="getRupeeImage(currentLevel, interview)"
													alt=""
												/>

												{{ interview.amount }}
											</article>
											<span v-else>₹{{ interview.amount }}</span>
										</div>
										<div
											:class="currentLevel != 2 && 'ml-3'"
											class="w-15 text-center d-flex align-items-center justify-content-center gap"
										>
											<img
												@click="
													showJobDetails(
														getTime(interview.interviewRequestID),
														interview,
														index
													)
												"
												class="pointer"
												v-b-tooltip.hover="'View'"
												src="../../assets/img/viewinterview/eye-icon.svg"
												alt=""
											/>
											<img
												@click="downloadResume(interview)"
												class="pointer"
												v-b-tooltip.hover="'Download Resume'"
												src="../../assets/img/viewinterview/download-icon.svg"
												alt=""
											/>
											<img
												v-if="
													(index == 2 ||
														(index == 1 &&
															getTime(interview.interviewRequestID) ==
																'ongoing' &&
															interview.panelMeetingStatus != 0)) &&
													interview.status != 2 && interview.panelMeetingStatus != 0
												"
												@click="openFeedback(interview)"
												v-b-tooltip.hover="'Give Feedback'"
												class="pointer"
												src="../../assets/img/viewinterview/assess-icon.svg"
												alt=""
											/>
											<img
												v-else-if="index == 2 && interview.status == 2"
												v-b-tooltip.hover="'View Feedback'"
												class="pointer"
												@click="viewFeedbackData(interview)"
												src="../../assets/img/viewinterview/viewfdbck.svg"
												alt=""
											/>
											<img
												v-else-if="
													(index == 2 &&
													interview.status != 2 &&
													interview.status != 0) || index == 2 && interview.panelMeetingStatus == 0
												"
												class="blue-dash"
												src="@/assets/paneldashboard/blue-dash.svg"
												alt=""
											/>
											<template
												v-if="index == 1 && interview.panelMeetingStatus != 0"
											>
												<img
													v-if="
														getTime(interview.interviewRequestID) != 'ongoing'
													"
													v-b-tooltip.hover="'Cancel Meeting'"
													@click="showCancelInterview(interview, getTime(interview.interviewRequestID))"
													class="pointer"
													src="../../assets/img/viewinterview/cross-icon.svg"
													alt=""
												/>

												<img
													@click="openMeetingLink(interview.meetingLink)"
													v-b-tooltip.hover="'Join Meeting'"
													class="pointer"
													src="../../assets/img/viewinterview/join-int.svg"
													alt=""
												/>
											</template>
											<template
												v-else-if="
													index == 1 && interview.panelMeetingStatus == 0
												"
											>
												<img
													class="blue-dash"
													src="@/assets/paneldashboard/blue-dash.svg"
													alt=""
												/>
												<img
													v-if="
														!(
															index == 1 &&
															getTime(interview.interviewRequestID) ==
																'ongoing' &&
															interview.panelMeetingStatus != 0
														)
													"
													class="blue-dash"
													src="@/assets/paneldashboard/blue-dash.svg"
													alt=""
												/>
											</template>
											<img
												v-if="index == 0"
												@click="showAcceptRejectModal(false, interview)"
												class="pointer"
												v-b-tooltip.hover="'Reject'"
												src="../../assets/img/viewinterview/crossred-icon.svg"
												alt=""
											/>
											<img
												v-if="index == 0"
												@click="showAcceptRejectModal(true, interview)"
												class="pointer"
												v-b-tooltip.hover="'Accept'"
												src="../../assets/img/viewinterview/tickgreen-icon.svg"
												alt=""
											/>
										</div>
									</div>
								</template>
							</div>

							<div
								v-if="total[index] > 0"
								class="int-paginaTion-new d-flex justify-content-between align-items-center"
							>
								<div class="d-flex">
									<span class="fam-mont fw-LM text-blue fs-12 mr-2 p-1"
										>Go to page</span
									>
									<div class="int-paginaTion-num">
										<b-form-input
											class="no-number"
											v-model="goToPageNumber"
											@keydown="checkDigit"
											@keyup.enter="
												isValidPage(goToPageNumber, index) &&
													goToPage(goToPageNumber, index)
											"
											type="number"
										>
										</b-form-input>
									</div>
									<div class="int-paginaTion-addbtn">
										<b-button
											@click="goToPage(goToPageNumber, index)"
											:disabled="!isValidPage(goToPageNumber, index)"
										>
											<img
												src="../../assets/img/viewinterview/page-arrow.svg"
												alt=""
											/>
										</b-button>
									</div>
								</div>
								<div class="d-flex justify-content-center pagination">
									<b-pagination
										:total-rows="total[index]"
										:per-page="pageCount"
										@input="getPanelData(index)"
										v-model="currentPage"
										align="center"
										first-number
										last-number
										limit="4"
									>
										<template #prev-text
											><span
												><img
													src="../../assets/img/viewinterview/pageLeft.svg"
													alt=""
												/> </span
										></template>
										<template #next-text
											><span
												><img
													src="../../assets/img/viewinterview/pageRight.svg"
													alt="" /></span
										></template>
									</b-pagination>
								</div>
								<div class="d-flex align-items-center">
									<PaginationCountSelect
										:pagecount="pageCount"
										@update-value="updatePageCount($event, index)"
									/>
									<div
										class="fam-mont fw-LM text-blue fs-12 mr-2 ml-4 d-flex align-items-center justify-content-end mb-1"
									>
										Results :
										<span class="ml-1"> {{ pageStart[index] }} </span>
										<span class="ml-1"> - {{ pageEnd[index] }} </span>
										<span class="pl-1"></span> of <span class="pr-1"></span
										>{{ total[index] }}
									</div>
								</div>
							</div>
						</div>
					</b-tab>
					</section>
				</b-tabs>
			</section>
			<section
				v-if="
					panelInterviews[currentLevel].length != 0 ||
					searchQuery != '' ||
					showLoader[currentLevel]
				"
				class="position-absolute w-20"
				style="top: 10px; right: 20px"
			>
				<div class="position-relative w-100 mr-4">
					<img
						class="lap-resumes-search-image-position"
						src="../../assets/headerSearch.svg"
						alt=""
					/>
					<b-form-input
						class="resumes-search-input"
						placeholder="Search"
						debounce="500"
						@update="
							(showLoader[currentLevel] = true),
								getPanelInterviews(currentLevel)
						"
						v-model.trim="searchQuery"
						type="search"
					>
					</b-form-input>
				</div>
			</section>
		</div>

		<b-modal
			id="giveFdbkModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showFeedBack"
			@hidden="closedFeedback()"
		>
			<section class="candash-modal-top px-3 py-2">
				<div class="ml-1">
					<div class="candash-modal-head">Give Feedback</div>
				</div>
				<div
					class="d-flex align-items-center gap-3 justify-content-end pointer"
				>
					<!-- <div class="ct-table-switch d-flex align-items-center apply-font">
						<b-form-checkbox
							switch
							style="margin-top: 5px !important"
						></b-form-checkbox>
						No Show
					</div> -->
					<img
						@click="closedFeedback()"
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
			</section>
			<section class="height">
				<GiveFeedback
					v-if="showFeedBack"
					@fromFeedback="closedFeedback($event)"
				/>
			</section>
		</b-modal>

			<b-modal
			id="View-Fdbk-Modal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showViewFeedback"
			@hidden="hideViewFeedback()"
		>
			<section class="candash-modal-top px-3 py-2">
				<div class="ml-1">
					<div class="candash-modal-head">View Feedback</div>
				</div>
				<div
					class="d-flex align-items-center gap-3 justify-content-end pointer"
				>
					<!-- <div class="ct-table-switch d-flex align-items-center apply-font">
						<b-form-checkbox
							switch
							style="margin-top: 5px !important"
						></b-form-checkbox>
						No Show
					</div> -->
					<img
						@click="hideViewFeedback()"
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
			</section>
			<section class="height">
				<ViewFeedback
					:interview="selectedInterview"
					@close-modal="hideViewFeedback()"
				/>
			</section>
		</b-modal>

		 <JobDetailsModal
		 v-if="showJobDetailsModal"
		 :showJobDetailsModal="showJobDetailsModal"
		 :interview="selectedInterview"
		 :level="selectedLevel"
		 @view-feedback="viewFeedbackData(selectedInterview)"
		 @accept-reject="showAcceptRejectModal($event,selectedInterview)"
		 @close-modal="hideJobDetails()"
		 @gotofeedback="goToFeedback()"
		  />


		  <AcceptRejectModal
		 v-if="showAcceptReject || cancelInterview"
		 :showAcceptReject="showAcceptReject || cancelInterview"
		 :interview="selectedInterview"
		 :type="actionType"
		 :cancel="cancelInterview"
		 :warning="warning"
		 @success="checkAndClose('success', $event),showLoader[currentLevel], getPanelInterviews(currentLevel)"
		 @close-modal="checkAndClose('close')"
		  />
	</main>
</template>

<script>
import "@/assets/paneldashboard/paneldashboard.css";
import PaginationCountSelect from "@/components/PaginationCountSelect.vue";
import GiveFeedback from "@/components/PanelDashboardModals/GiveFeedback.vue";
import panelDashboardMixin from "@/components/mixin/panelDashboardMixin";
import {
	downloadResume,
	openMeetingLink,
	isWithinTwoHours,
	getFormattedTime,
	getAmountToolTip,
	formattedArray,
	showRescheduleText,
	showRescheduled
} from "@/components/PanelDasboard/panelHelpers";
export default {
	name: "ViewAllInterviews",
	data() {
		return {
			tabIndex: 0,
			goToPageNumber: null,
			currentPage: 1,
			interviewTimes: [],
			intervalId: null,
			showFeedBack: false,
			isLaptop: false,
		};
	},
	mixins: [panelDashboardMixin],
	components: {
		PaginationCountSelect,
		GiveFeedback,
	},
	mounted() {
		this.startAutoUpdate();
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeDestroy() {
		clearInterval(this.intervalId); // Stop interval when component is destroyed
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	async created(){
		if(this.userInfo.isPanelSuspended && (this.$route.query.level == 0 || this.$route.query.level == 1)){
			this.gotToViewAll(2);
		}
		if(this.$route.query.level == undefined || this.$route.query.level == null){
			if(this.userInfo.isPanelSuspended) this.gotToViewAll(2);
			else this.gotToViewAll(0);
		}
		this.tabIndex = this.currentLevel = parseInt(this.$route.query.level);
		this.showLoader[this.currentLevel] = true;
		await this.getPanelInterviews(this.currentLevel);
	},
	watch:{
		$route(val){
			this.currentLevel = parseInt(val.query.level);
		},
		tabIndex(val){
			this.searchQuery = "";
			this.sortBy = "createdAt";
			this.sortOrder = -1;
			if(!this.userInfo.isPanelSuspended){
				this.gotToViewAll(val);
				this.getPanelData(val);
			}
		}
	},
	methods:{
		showRescheduled(interview){
			return showRescheduled(interview, this.userInfo.userID);
		},
		showRescheduleText(interview){
			return showRescheduleText(interview, this.userInfo.userID);
		},
		goToFeedback() {
				this.showFeedBack = true;
		},
		showTab(index){
			if(this.userInfo.isPanelSuspended) return index != 1 && index != 0;
			return true;
		},
		formattedArray(skills){
			return formattedArray(skills);
		},
		getAmountToolTip(status) {
			return getAmountToolTip(this.currentLevel, status);
		},
		getFormattedTime(interview) {
			return getFormattedTime(interview);
		},
		getTime(id) {
			let val = this.interviewTimes.find((obj) => obj.id == id)
				? this.interviewTimes.find((obj) => obj.id == id).timeRemaining
				: null;
			return val;
		},
		startAutoUpdate() {
			// Run initially
			this.updateInterviewTimes();
			// Run every 1 minute
			this.intervalId = setInterval(() => {
				this.updateInterviewTimes();
			}, 60000);
		},
		updateInterviewTimes() {
			this.interviewTimes = this.panelInterviews[this.currentLevel].map(
				(interview) => ({
					id: interview.interviewRequestID,
					timeRemaining: this.isWithinTwoHours(
						interview.slotStartTime + ` -${interview.slot.split("-")[1]}`
					),
				})
			);
		},
		isWithinTwoHours(time) {
			return isWithinTwoHours(time);
		},
		openMeetingLink(link) {
			openMeetingLink(link);
		},
		downloadResume(interview) {
			downloadResume(interview);
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
			if (!this.isLaptop) this.$router.push({ name: "PanelDashboard" });
		},
		closedFeedback(val) {
			if (val && val.submitted) {
				this.showFeedBack = false;
				this.successModal("Success", "Feedback submitted successfully.");
				this.getPanelData(parseInt(this.$route.query.level));
			} else {
				this.showFeedBack = false;
				this.$store.commit("candidateVUEX/setFeedbackData", {});
			}
		},
		sortData(key, type) {
			this.sortBy = key;
			this.sortOrder = type;
			this.showLoader[this.currentLevel] = true;
			this.getPanelInterviews(this.currentLevel);
		},
		async getPanelData(index) {
			this.pages[index] = this.currentPage - 1;
			this.showLoader[index] = true;
			await this.getPanelInterviews(index);
		},
		updatePageCount(pageCount, index) {
			this.pageCount = pageCount;
			this.currentPage = 1;
			this.pages[index] = this.currentPage - 1;
			this.showLoader[index] = true;
			this.getPanelInterviews(index);
		},
		isValidPage(page, index) {
			return /^\d*$/.test(page) && page > 0 && page <= this.total[index];
		},
		goToPage(pageNumberToGo, index) {
			this.currentPage = pageNumberToGo;
			this.goToPageNumber = null;
			this.pages[index] = this.currentPage - 1;
		},
		checkDigit(event) {
			if (event.key.length === 1 && isNaN(Number(event.key))) {
				event.preventDefault();
			}
		},
		openFeedback(interview) {
			let basicInfo = {
				name: interview.name,
				panelName: interview.emailID,
				formID: interview.interviewInfo.feedbackFormID,
				licenseKey: interview.licenseKey,
				interviewID: interview.interviewID,
			};
			this.$store.commit("candidateVUEX/setFeedbackData", basicInfo);
			if (this.isLaptop) {
				this.showFeedBack = true;
			} else {
				this.$router.push({ name: "GiveFeedback" });
			}
		},
	},
};
</script>

<style scoped>
.main-container {
	height: calc(100vh - 60px);
	position: relative;
	top: 60px;
	padding: 15px 20px 0 75px;
	background-color: #e9ecef;
}

.cand-header {
	max-width: unset;
}

.int-body-main {
	background: #fff;
	height: calc(100vh - 157px);
	box-shadow: 0px 0px 14px 0px #c4c4c480;
	border-radius: 5px;
}

.int-main-table {
	width: 100%;
	position: relative;
	overflow-x: auto;
	overflow-y: hidden;
	padding: 0 15px;
	height: calc(100vh - 245px);
}

.int-table-head {
	min-width: 1315px;
	max-width: 100%;
	display: flex;
	align-items: center;
	padding: 10px 0;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	color: #20639b;
	font-family: "lato", sans-serif;
	background: #e9f0f5;
}

.int-table-body {
	min-width: 1315px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 334px);
}

.int-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 0.5px solid #e5e5e5;
	background: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 15px;
	color: #20639b;
	font-family: "lato", sans-serif;
	padding: 15px 0;
	margin: 18px 0;
	cursor: default;
}

.blue-line {
	width: 4px;
	height: 90%;
	border-radius: 3px;
	position: absolute;
	left: 2px;

	background: #20639b;
}

.tag-outer{
	gap: 10px;
    top: -12px !important;
    left: 20px;
}

.label-card{
	padding: 4px 10px;
	-webkit-backdrop-filter: blur(1.91214px);
	backdrop-filter: blur(1.91214px);
	border-radius: 3.82428px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 15px;
	color: #ffffff;
}
.greenCard {
	background: linear-gradient(90deg, rgba(3, 142, 0, 0.3) 0%, #038e00 100%);
}

.redCard {
	background: linear-gradient(90deg, rgba(235, 0, 2, 0.3) 0%, #eb0002 100%);
}

.orangeCard {
	background: linear-gradient(90deg, rgba(242, 139, 43, 0.3) 0%, #f28b2b 100%);
}

.resched-card {
	background: linear-gradient(90deg, rgba(255, 193, 33, 0.45) -6.55%, #FFC121 100%);
}

.rescheduled-card {
	background: linear-gradient(90deg, rgba(32, 99, 155, 0.45) -6.55%, #20639B 100%);
}

.gap {
	gap: 25px;
}

.modal-top {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}
</style>

<style>
.int-control-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	margin-bottom: 2px;
	font-weight: 700 !important;
	font-size: 16px !important;
	color: #20639b !important;
	font-family: "lato", sans-serif !important;
}

.int-control-tabs a {
	color: #000000;
	font-weight: bold;
	font-size: 16px;
	font-family: "lato", sans-serif;
	line-height: 21px;
}

.int-control-tabs li {
	text-align: center;
}

.int-control-tabs .nav-tabs .nav-link {
	border: unset;
}

.int-control-tabs .nav-tabs {
	border-bottom: 1px solid #d9d9d9;
	padding-left: 20px;
}

.int-control-tabs .nav-link {
	display: block;
	padding: 15px;
}

.int-control-tabs .nav-tabs .nav-link.active {
	position: relative !important;
	border-bottom: 3px solid #20639b !important;
}

#acceptrejectmodal .modal-body {
	padding: 0;
}
</style>
